module.exports = require('jadelet').exec(["menu",{"class":[{"bind":"class"}],"click":{"bind":"click"},"style":[{"bind":"style"}]},[{"bind":"items"}]]);